import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const Loader = styled.div`
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  animation: spin 1s linear infinite;
  border: 3px solid transparent;
  border-top-color: ${({ invertedColor, theme }) => invertedColor ? theme.secondaryFontColor : theme.highlightColor};
  border-radius: 50%;
  height: 24px;
  width: 24px;
  margin: 16px auto;
  box-sizing: border-box;

`;

Loader.propTypes = {
  invertedColor: PropTypes.bool,
}

Loader.defaultProps = {
  invertedColor: false,
}

const ToolLoader = styled(Loader)`
  height: 80px;
  width: 80px;
  border-width: 5px;
  border-color: #fff;
  border-top-color: #979797;
`;

export {
  Loader,
  ToolLoader
}

export default Loader;
